/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';
import { RouterProps, showNotification } from '../App';
import { SkeletonLoader } from '../components/loading/SkeletonLoader';
import SettingsIcon from '@material-ui/icons/Settings';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import EmailingTab from './tabs/EmailingTab';
import { retrieveSystemSettingsNamesQueryData, SettingName, SettingNotificationSubscription, SystemSettingsNamesData } from './FirmSettingConfigurationRepository';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import ContactsIcon from '@material-ui/icons/Contacts';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import EnquiryDefaultTab from './tabs/EnquiryDefaultTab';
import { client } from '..';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import FirmDetailsTab from './tabs/FirmDetailsTab';
import RegionalTab from './tabs/RegionalTab';
import TimeRecordingTab from './tabs/TimeRecordingTab';
import TimeRecordingDefaultsTab from './tabs/TimeRecordingDefaultsTab';
import ConnectTab from './tabs/ConnectTab';
import TimeRecordingWarningDefaultsTab from './tabs/TimeRecordingWarningDefaultsTab';
import InprotechTab from './tabs/InprotechTab';
// import AgeingTab from './tabs/AgeingTab';
// import PollIcon from '@material-ui/icons/Poll';
// import ChartDefaultsTab from './tabs/ChartDefaultsTab';
import PhoneMessageDefaultConfigurationTab from './tabs/PhoneMessageDefaultConfigurationTab';
import TaskDefaultConfigurationTab from './tabs/TaskDefaultConfigurationTab';
// import { LearnMoreEnum } from '../learnMore/LearnMorePage';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import ClientAndContactsDefaultConfigurationTab from './tabs/ClientAndContactsDefaultConfigurationTab';
import FinancialThresholdsTab from './tabs/FinancialThresholdsTab';
import SecurityTab from './tabs/SecurityTab';
import MarketingSettingsTab from './tabs/MarketingSettingsTab';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import ExtensionIcon from '@material-ui/icons/Extension';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { FilterChip, FilteredVerticalTabPage, SidebarGroup, SidebarItem } from '../v2/layouts/FilteredVerticalTabPage';

export enum FirmSettingConfigurationList {
    // Ageing = 0,
    Security,
    EmailConfiguration,
    EnquiryDefaultConfiguration,
    FirmDetails,
    Regional,
    TimeRecording,
    TimeRecordingDefaults,
    Connect,
    MarketingSettings,
    TimeRecordingWarningDefaults,
    Inprotech,
    ChartDefaults,
    PhoneMessageDefaultConfiguration,
    TaskDefaultConfiguration,
    ClientAndContactsDefaultConfiguration,
    FinancialThresholds,
    BulkMailingSettings
}

interface FirmSettingConfigurationPageState {
    selectedTable: FirmSettingConfigurationList | null;
    tabs: SettingName[];
    isTabLoading: boolean;
}

interface FirmSettingConfigurationPageProps extends RouterProps {

}

const groupStyles: { [key: string]: { iconBg: string; iconColor: string } } = {
    client: { iconBg: '#f5f3ff', iconColor: '#7c3aed' },
    task: { iconBg: '#fff3e0', iconColor: '#e65100' },
    time: { iconBg: '#dbeafe', iconColor: '#1d4ed8' },
    communication: { iconBg: '#e3f2fd', iconColor: '#1565c0' },
    firm: { iconBg: '#ccfbf1', iconColor: '#0f766e' },
    integration: { iconBg: '#f3f4f6', iconColor: '#6b7280' },
    finance: { iconBg: '#fffbeb', iconColor: '#b45309' },
    security: { iconBg: '#fdecea', iconColor: '#c62828' },
};

const groupByInternalName: { [key: string]: string } = {
    [FirmSettingConfigurationList[FirmSettingConfigurationList.EnquiryDefaultConfiguration]]: 'client',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.ClientAndContactsDefaultConfiguration]]: 'client',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.TaskDefaultConfiguration]]: 'task',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.TimeRecording]]: 'time',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.TimeRecordingDefaults]]: 'time',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.TimeRecordingWarningDefaults]]: 'time',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.EmailConfiguration]]: 'communication',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.MarketingSettings]]: 'communication',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.PhoneMessageDefaultConfiguration]]: 'communication',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.FirmDetails]]: 'firm',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.Regional]]: 'firm',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.Connect]]: 'integration',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.Inprotech]]: 'integration',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.FinancialThresholds]]: 'finance',
    [FirmSettingConfigurationList[FirmSettingConfigurationList.Security]]: 'security',
};

const TAB_CONTENT: { [key in FirmSettingConfigurationList]?: React.ReactNode } = {
    [FirmSettingConfigurationList.EmailConfiguration]: <EmailingTab />,
    [FirmSettingConfigurationList.EnquiryDefaultConfiguration]: <EnquiryDefaultTab />,
    [FirmSettingConfigurationList.Security]: <SecurityTab />,
    [FirmSettingConfigurationList.FirmDetails]: <FirmDetailsTab />,
    [FirmSettingConfigurationList.Regional]: <RegionalTab />,
    [FirmSettingConfigurationList.TimeRecording]: <TimeRecordingTab />,
    [FirmSettingConfigurationList.TimeRecordingDefaults]: <TimeRecordingDefaultsTab />,
    [FirmSettingConfigurationList.Connect]: <ConnectTab />,
    [FirmSettingConfigurationList.MarketingSettings]: <MarketingSettingsTab />,
    [FirmSettingConfigurationList.TimeRecordingWarningDefaults]: <TimeRecordingWarningDefaultsTab />,
    [FirmSettingConfigurationList.Inprotech]: <InprotechTab />,
    [FirmSettingConfigurationList.PhoneMessageDefaultConfiguration]: <PhoneMessageDefaultConfigurationTab />,
    [FirmSettingConfigurationList.ClientAndContactsDefaultConfiguration]: <ClientAndContactsDefaultConfigurationTab />,
    [FirmSettingConfigurationList.TaskDefaultConfiguration]: <TaskDefaultConfigurationTab />,
    [FirmSettingConfigurationList.FinancialThresholds]: <FinancialThresholdsTab />,
};

export default function FirmSettingConfigurationPage(props: FirmSettingConfigurationPageProps) {

    const [pageState, setPageState] = useState<FirmSettingConfigurationPageState>({
        selectedTable: null,
        tabs: [],
        isTabLoading: true,
    });

    // tslint:disable-next-line: no-any
    let routeCommand = props.match.params.command;

    useEffect(() => {

        fetchTabData();

        var routeTab: FirmSettingConfigurationList = FirmSettingConfigurationList[props.match.params.tab as keyof typeof FirmSettingConfigurationList];
        // tslint:disable-next-line: no-console
        console.log('routeCommand', routeCommand);

        setPageState({
            ...pageState,
            selectedTable: routeTab !== undefined ? routeTab : pageState.selectedTable
        });

    // tslint:disable-next-line: align
    }, []);

    useEffect(() => {
        const subscribeSettingNotificationObj = subscribeSettingNotification();
        // Cleanup
        return () => {
            subscribeSettingNotificationObj.unsubscribe();
        };

    // tslint:disable-next-line: align
    }, []);

    const subscribeSettingNotification = () => {
        return (
            client
                .subscribe({
                    fetchPolicy: 'no-cache',
                    query: SettingNotificationSubscription,
                    variables: {},
                })
                .subscribe({
                    // tslint:disable-next-line:no-any
                    next(results: any) {
                        if (results.data.settingNotification.status) {
                            showNotification('Success', results.data.settingNotification.message, 'info');

                        } else {
                            showNotification('Failed', results.data.settingNotification.message, 'error');
                        }
                    },
                    // tslint:disable-next-line:no-any
                    error(err: any) {
                        // tslint:disable-next-line:no-console
                        console.error(err);
                        showNotification(null, err, 'error');
                    },
                })
        );
    };

    const fetchTabData = () => {
        retrieveSystemSettingsNamesQueryData(
            true,
            // tslint:disable-next-line: no-console
            (data: SystemSettingsNamesData) => onFirmSettingTabRetrieved(data),
            // tslint:disable-next-line: no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onFirmSettingTabRetrieved = (data: SystemSettingsNamesData) => {
        const tabs = data.settings.systems.settingNames.settingName;

        setPageState((prevState) => {
            const groupOrder = groups.map(group => group.key);

            const groupedTabs = [...tabs].sort((tabA, tabB) => {
                const groupIndexA = groupOrder.indexOf(groupByInternalName[tabA.internalName] ?? 'firm');
                const groupIndexB = groupOrder.indexOf(groupByInternalName[tabB.internalName] ?? 'firm');

                return groupIndexA - groupIndexB;
            });

            const defaultTab = groupedTabs.length > 0
                ? FirmSettingConfigurationList[groupedTabs[0].internalName as keyof typeof FirmSettingConfigurationList]
                : undefined;

            return {
                ...prevState,
                tabs,
                isTabLoading: false,
                selectedTable: prevState.selectedTable ?? defaultTab ?? null
            };
        });
    };

    const getIcon = (internalName: string) => {

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.Security]) {
            return <VpnKeyOutlinedIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.FirmDetails]) {
            return <ListAltOutlinedIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.Regional]) {
            return <RoomOutlinedIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.TimeRecording]) {
            return <TimerOutlinedIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.TimeRecordingDefaults]) {
            return <AccessTimeIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.EmailConfiguration]) {
            return <EmailOutlinedIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.EnquiryDefaultConfiguration]) {
            return <ContactMailIcon />;
        }

        // if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.ChartDefaults]) {
        //     return <PollIcon />;
        // }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.PhoneMessageDefaultConfiguration]) {
            return <PermPhoneMsgIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.ClientAndContactsDefaultConfiguration]) {
            return <ContactsIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.TaskDefaultConfiguration]) {
            return <AssignmentLateIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.MarketingSettings]) {
            return <AnnouncementIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.Connect]) {
            return <SettingsEthernetIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.Inprotech]) {
            return <ExtensionIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.FinancialThresholds]) {
            return <AttachMoneyIcon />;
        }

        if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.TimeRecordingWarningDefaults]) {
            return <TimerOutlinedIcon />;
        }

        return <SettingsIcon />;
    };

    const isHasAccess = (internalName: string): boolean => {

        // if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.EmailConfiguration]) {
        //     return UserFeature.HasAccess(UserFeatureEnum.hasInnographyLink);
        // }

        // if (internalName === FirmSettingConfigurationList[FirmSettingConfigurationList.EnquiryDefaultConfiguration]) {
        //     return UserFeature.HasAccess(UserFeatureEnum.hasVisionSix);
        // }

        return true;
    };

    const onClickBack = () => {
        props.history.push('/configurationDashboard');
    };

    // const onLearnMore = () => {
    //     props.history.push({
    //         pathname: `/learnMore/${LearnMoreEnum[LearnMoreEnum.FIRM_STRUCTURE]}`,
    //     });
    // };

    const groups: SidebarGroup[] = [
        { key: 'communication', label: 'Communication', icon: <EmailOutlinedIcon />, iconColor: groupStyles.communication.iconColor },
        { key: 'client', label: 'Enquiry & Client', icon: <PeopleAltIcon />, iconColor: groupStyles.client.iconColor },
        { key: 'finance', label: 'Finance', icon: <AttachMoneyIcon />, iconColor: groupStyles.finance.iconColor },
        { key: 'firm', label: 'Firm & Regional', icon: <ListAltOutlinedIcon />, iconColor: groupStyles.firm.iconColor },
        { key: 'integration', label: 'Integrations', icon: <SettingsEthernetIcon />, iconColor: groupStyles.integration.iconColor },
        { key: 'security', label: 'Security', icon: <VpnKeyOutlinedIcon />, iconColor: groupStyles.security.iconColor },
        { key: 'task', label: 'Task Management', icon: <AssignmentLateIcon />, iconColor: groupStyles.task.iconColor },
        { key: 'time', label: 'Time Recording', icon: <TimerOutlinedIcon />, iconColor: groupStyles.time.iconColor },
    ];

    const filters: FilterChip[] = [
        { key: 'all', label: 'All', icon: <ViewModuleIcon fontSize="small" /> },
        { key: 'communication', label: 'Communication', icon: <EmailOutlinedIcon fontSize="small" /> },
        { key: 'client', label: 'Enquiry & Client', icon: <PeopleAltIcon fontSize="small" /> },
        { key: 'finance', label: 'Finance', icon: <AttachMoneyIcon fontSize="small" /> },
        { key: 'firm', label: 'Firm & Regional', icon: <ListAltOutlinedIcon fontSize="small" /> },
        { key: 'integration', label: 'Integrations', icon: <SettingsEthernetIcon fontSize="small" /> },
        { key: 'security', label: 'Security', icon: <VpnKeyOutlinedIcon fontSize="small" /> },
        { key: 'task', label: 'Task', icon: <AssignmentLateIcon fontSize="small" /> },
        { key: 'time', label: 'Time Recording', icon: <TimerOutlinedIcon fontSize="small" /> },
    ];

    const sidebarItems: SidebarItem[] = pageState.tabs
        .filter(tab => isHasAccess(tab.internalName))
        .map(tab => {
            const group = groupByInternalName[tab.internalName] ?? 'firm';

            return {
                id: tab.internalName,
                name: tab.title,
                description: tab.description,
                group,
                icon: getIcon(tab.internalName),
                iconBg: groupStyles[group]?.iconBg,
                iconColor: groupStyles[group]?.iconColor,
            };
        });

    const onItemSelect = (item: SidebarItem) => {
        const value: FirmSettingConfigurationList = FirmSettingConfigurationList[item.id as keyof typeof FirmSettingConfigurationList];

        setPageState({
            ...pageState,
            selectedTable: value
        });

        props.history.push(`/firmSettingConfiguration/${item.id}`);
    };

    const renderContent = () => {
        if (pageState.selectedTable === null) {
            return <SkeletonLoader variant="form" rows={4} columns={2} />;
        }

        return TAB_CONTENT[pageState.selectedTable] ?? null;
    };

    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            flexDirection="column"
        >
            <FilteredVerticalTabPage
                icon={<SettingsIcon fontSize="small" />}
                title="Firm Setting"
                subtitle="Manage configuration settings used throughout the firm"
                onBack={onClickBack}
                backTooltip="Back to configuration dashboard"
                // onLearnMore={onLearnMore}

                enableSearch
                searchPlaceholder="Search firm settings…"

                enableFilter
                filterChips={filters}

                sidebarGroups={groups}
                sidebarItems={sidebarItems}
                selectedId={pageState.selectedTable !== null ? FirmSettingConfigurationList[pageState.selectedTable] : undefined}
                sidebarLoading={pageState.isTabLoading}
                onItemSelect={onItemSelect}

                renderContent={renderContent}
                sidebarWidth={340}
            />
        </Box>
    );
}
